import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  borderWidth: 0,
  borderBlockStartWidth: Spacing.XS / 2,
  borderStyle: 'solid',
  borderColor: Color[theme].Translucent.N08,
})

export const day = ({ theme }: StyleProps): CSSObject => ({
  ...Typography.T500,
  // this is implicitly getting an extra pixel
  blockSize: Spacing.M * 2,
  cursor: 'default',
  inlineSize: Spacing.L,
  // subtract one pixel to compensate for extra pixel of height
  paddingBlockStart: Spacing.XS * 1.75,
  textAlign: 'center',
  color: Color[theme].Text.Default,
})
